export default __webpack_public_path__ + "static/media/ArrowRight.7f55ac25.svg";